import { Alert, Typography } from 'antd'
import { format, formatRelative, parseISO } from 'date-fns'
import { getBookingLimitMsg, getCourtsText } from '../../util/bookingUtil'
import { durationInWords, formatDateTime } from '../../util/dateTimeUtil'
import { getServerDate, isToday, isTomorrow, isYesterday } from '../../util/serverTimeUtil'

import { enUS } from 'date-fns/locale'

const { Paragraph } = Typography

const locale = {
  ...enUS,
  formatRelative: (token) =>
    ({
      yesterday: "'yesterday at' h:mma",
      today: "'today at' h:mma",
    })[token],
}

const smartFormat = (originalString) => {
  // If minutes are 0, use 'ha' (e.g., 12pm).
  // Otherwise, use 'h:mma' (e.g., 12:25pm).
  const minutes = Number(formatDateTime(originalString, 'mm'))
  const pattern = minutes === 0 ? 'ha' : 'h:mma'

  return formatDateTime(originalString, pattern)
}

const getSmartDateLabel = (date) => {
  if (isToday(date)) {
    return 'today'
  }
  if (isYesterday(date)) {
    return 'yesterday'
  }
  if (isTomorrow(date)) {
    return 'tomorrow'
  }
  return format(date, 'MMMM d')
}

const NextBookingMessage = ({ maxBookingTime, nextAllowed, lastBooking }) => {
  if (!nextAllowed || !lastBooking) {
    return null
  }

  const lastBookingTime = new Date(lastBooking?.createdAt)

  const lastBookingStr = `${getCourtsText(lastBooking)} ${getSmartDateLabel(parseISO(lastBooking.startTime))} @ ${smartFormat(lastBooking.startTime)}`

  const content = (
    <>
      <Paragraph className="note" style={{ marginBottom: '0.5em' }}>
        <b>
          You'll be able to book another court in {durationInWords(nextAllowed, false)} (at{' '}
          {formatDateTime(nextAllowed, 'h:mm a')})
        </b>
        .{' '}
        <span style={{ fontSize: '.9em', fontWeight: 'normal' }}>
          {getBookingLimitMsg(maxBookingTime)}. You booked a court{' '}
          {formatRelative(lastBookingTime, getServerDate(), { locale })} ({lastBookingStr}).
        </span>
      </Paragraph>
    </>
  )

  return <Alert type="bookingTimer" message={content} />
}

export default NextBookingMessage
